import React, { useState, useEffect } from "react";
import { ReactComponent as DoneIcon } from "../../images/done.svg";
import { ReactComponent as NoData } from "../../images/no_data.svg";

import "./StepProgress.css";
import { Button } from "antd";

export const StepProgress = ({
  currentSection = 1,
  totalSections,
  finalAction,
  onCurrentSectionChange,
  nextBtnDisabled = false,
  backBtnDisabled = false,
  addClass,
  backClass,
  nextClass,
  actionClass,
  commonBtnClass,
  backName = "Back",
  nextName = "Next",
  actionName = "Finish",
  hideProgressBar = false,
  stepsData,
  children,
  isStepCompleted,
}) => {
  const [currentSectionState, setCurrentSectionState] =
    useState(currentSection);

  useEffect(() => {
    setCurrentSectionState(currentSection)
  }, [currentSection])
  const [ariaLiveContent, setAriaLiveContent] = useState("");

  const progressBarWidth = `${(currentSectionState / totalSections) * 100}%`;

  const nextBtnDisabledState = currentSectionState === totalSections;

  const changeSection = (action, step) => {
    if (action === "prev" && currentSectionState > 1) {
      //setCurrentSectionState((prev) => prev - 1);
      onCurrentSectionChange(currentSectionState - 1, currentSection);
      setAriaLiveContent(`navigated to section ${currentSectionState - 1}`);
    } else if (action === "next" && currentSectionState < totalSections) {
      //setCurrentSectionState((prev) => prev + 1);
      onCurrentSectionChange(currentSectionState + 1, currentSection);
      setAriaLiveContent(`navigated to section ${currentSectionState + 1}`);
    } else {
      onCurrentSectionChange(step, currentSection);
      setAriaLiveContent(`navigated to section ${step}`);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAriaLiveContent("");
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [ariaLiveContent]);

  return (
    <div className={`progress-step ${addClass ? addClass : ""}`}>
      {hideProgressBar && (
        <div
          className="common-progress"
          role="progressbar"
          aria-valuemin={1}
          aria-valuemax={totalSections}
          aria-valuenow={currentSectionState}
          aria-valuetext={`Section ${currentSectionState} of ${totalSections}`}
          aria-live="polite"
        >
          <div
            className="common-progress-bar"
            style={{
              width: progressBarWidth,
            }}
          />
        </div>
      )}
      {!hideProgressBar && stepsData && (
        <div className="step-list-group">
          {stepsData.map((step) => (
            <div
              className={`step-progress-list ${currentSectionState === step.step ? "current-active" : ""
                } ${currentSectionState > step.step ? "compiled-step" : ""}`}
              key={step.step}
              onClick={() => {
                if (step.step > currentSectionState) {
                  changeSection("multi", step.step)
                } else if (step.step < currentSectionState) {
                  changeSection("multi", step.step)
                } else {
                  return;
                }
              }}

            >
              <h5>
                Step {step.step}
                {/**currentSectionState > step.step && */}
                {isStepCompleted[`${step.step}`] !== "" && step.step !== 4 ? isStepCompleted[`${step.step}`] ? (
                  <span>
                    <DoneIcon />
                  </span>
                ) : (
                  <span>
                    <NoData />
                  </span>
                ) : ("")}
              </h5>
              <h4>{step.name}</h4>
            </div>
          ))}
        </div>
      )}
      <section
        className={`step-section-block step-${currentSectionState}-progress`}
      >
        {children}
        <div className="progress-btn-block">
          {currentSectionState !== 1 && (
            <Button
              type="button"
              className={`btn ${backClass ? backClass : ""} ${commonBtnClass ? commonBtnClass : ""
                }`}
              disabled={backBtnDisabled}
              onClick={() => {
                sessionStorage.setItem('fromBackButton', 'true');
                changeSection("prev");
              }}
            >
              {backName}
            </Button>
          )}
          {!nextBtnDisabledState && (
            <Button
              type="button"
              className={`btn ${nextClass ? nextClass : ""} ${commonBtnClass ? commonBtnClass : ""
                }`}
              disabled={nextBtnDisabledState || nextBtnDisabled}
              onClick={() => {
                sessionStorage.setItem('fromBackButton', 'true');
                changeSection("next")
              }}
            >
              {nextName}
            </Button>
          )}
          {nextBtnDisabledState && (
            <Button
              type="button"
              className={`btn ${actionClass ? actionClass : ""} ${commonBtnClass ? commonBtnClass : ""
                }`}
              disabled={!nextBtnDisabledState}
              onClick={finalAction}
            >
              {actionName}
            </Button>
          )}
        </div>
        <div
          className="aria-live-region"
          aria-live="polite"
          aria-atomic="true"
          style={{ position: "absolute", left: "-9999px" }}
        >
          {ariaLiveContent}
        </div>
      </section>
    </div>
  );
};
